<div class="select-wrapper custom-filter-wrapper" [class.opened]="dropdownOpen()">
  <label class="visually-hidden" [for]="filterInputId">{{ filterInputLabel() }}</label>
  <input
    [id]="filterInputId"
    #selectTrigger
    type="text"
    class="select-input form-control filter-header-input search-filter slick-filter slick-filter-custom"
    tabindex="0"
    readonly
    (click)="toggleDropdown()"
    [disabled]="disabled"
    [class.filled]="!!filterInputValue()"
    (keydown)="handleKeydown($event)"
    [value]="filterInputValue()"
    [placeholder]="filterInputPlaceholderValue()"
  />
  <span class="slick-filter-icons"></span>
</div>

<ng-template #dropdownTemplate>
  <div
    class="zn-dropdown-menu dropdown-menu show custom-dropdown filter-mode"
    (keydown)="handleKeydown($event)"
    [class.open-up]="openUp"
  >
    @if (showSearch()) {
      <div class="form-control-container filter-search">
        <div class="input-group">
          <div class="input-group-text">
            <i class="bi" [ngClass]="search() ? 'bi-funnel-fill' : 'bi-funnel'"></i>
          </div>
          <input
            type="text"
            class="form-control"
            [placeholder]="localizationResource() + '::ZnSearchPlaceholder' | abpLocalization"
            [ngModel]="search()"
            (ngModelChange)="onSearchChange($event)"
            (keydown)="handleKeydown($event)"
          />
        </div>
      </div>
    }

    <div class="zn-dropdown-menu-header d-flex align-items-center justify-content-between gap-2">
      <div class="zn-select-all option-item" style="cursor: pointer" (click)="handleSelectAllContainerClick($event)">
        <input
          [id]="masterCheckId"
          class="form-check-input check-lg"
          type="checkbox"
          [checked]="isSelectAllCheckboxChecked()"
          [indeterminate]="isSelectAllCheckboxIndeterminate()"
          tabindex="-1"
          (change)="toggleSelectAll(); $event.stopPropagation()"
        />
        <label [for]="masterCheckId" class="form-check-label">
          {{ localizationResource() + '::ZnSelectAll' | abpLocalization }}
        </label>
      </div>

      @if (optionsLoader()) {
        <button
          type="button"
          class="zn-select-action btn btn-tertiary"
          (click)="refreshOptions()"
          [disabled]="disabled || loading()"
          [attr.aria-label]="'::Refresh' | abpLocalization"
          [title]="'::Refresh' | abpLocalization"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      }
    </div>
    <hr class="zn-separator">
    <div class="zn-dropdown-menu-body" (scroll)="onOptionsScroll($event)">
      @if (loading()) {
        <div class="text-disabled">{{ localizationResource() + '::ZnSelectLoading' | abpLocalization }}</div>
      }

      @if (!loading() && filteredOptions().length === 0) {
        <div class="text-disabled">{{ localizationResource() + '::ZnSelectResultNotFound' | abpLocalization }}</div>
      }

      @for (option of filteredOptions(); track option.key) {
        <div
          class="option-item d-flex align-items-center"
          (click)="toggleOption(option.key)"
          [class.selected]="isOptionSelected(option.key)"
          [class.active]="isActiveIndex($index)"
          [attr.tabindex]="isActiveIndex($index) ? 0 : -1"
        >
          <input class="form-check-input check-lg" type="checkbox" [checked]="isOptionSelected(option.key)" tabindex="-1" />
          <span [title]="option.value">{{ option.value }}</span>
        </div>
        <hr class="zn-separator">
      }

      @if (loadingMore()) {
       <zn-button 
          [label]="`${localizationResource()}::ZnSelectLoading` | abpLocalization"
          type="tertiary"
          size="normal"
          loading="true"
          disabled="true"
          loadingIconPosition="left"></zn-button>
      }
    </div>

    @if (deferSelection()) {
      <div class="zn-dropdown-menu-footer d-flex justify-content-center">
        <button type="button" class="btn btn-primary" (click)="applyDraftSelection()">
          {{ localizationResource() + '::Apply' | abpLocalization }}
        </button>
      </div>
    }
  </div>
</ng-template>
